<ng-template #dialog>
  @if (headerText || headerKey) {
    <div mat-dialog-title class="header">
      {{ headerText ? headerText : (headerKey | translate) }}
      @if (subTitle) {
        <div class="subtitle"> {{ subTitle }}</div>
      }
    </div>
  }
  <mat-dialog-content>
    <ng-content></ng-content>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button class="danger" mat-button mat-dialog-close (click)="onClickButton(false)">
      <mat-icon>close</mat-icon>
      {{ 'Cancel' | translate }}
    </button>
    @if (!hideConfirmButton) {
      <button class="primary" [class.disabled]="disableConfirmButton || !valid()" mat-button (click)="onClickButton(true)" [disabled]="disableConfirmButton">
        <mat-icon>check</mat-icon>
        {{ 'Confirm' | translate }}
      </button>
    }
  </mat-dialog-actions>
</ng-template>
